var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassify2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/system/classify_2_line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3905 1.83828C10.9112 1.31758 11.7555 1.31758 12.2761 1.83828L14.1617 3.72389C14.6825 4.24459 14.6825 5.08881 14.1617 5.60951L12.2761 7.49513C11.7555 8.0158 10.9112 8.0158 10.3905 7.49513L8.50493 5.60951C7.9842 5.08881 7.9842 4.24459 8.50493 3.72389L10.3905 1.83828ZM11.3333 2.78109L9.44773 4.66671L11.3333 6.55233L13.2189 4.66671L11.3333 2.78109Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.00006C6.7364 2.00006 7.33333 2.59701 7.33333 3.33339V6.00006C7.33333 6.73647 6.7364 7.33339 6 7.33339H3.33333C2.59695 7.33339 2 6.73647 2 6.00006V3.33339C2 2.59701 2.59695 2.00006 3.33333 2.00006H6ZM6 3.33339H3.33333V6.00006H6V3.33339ZM14 10.0001C14 9.26367 13.4031 8.66673 12.6667 8.66673H10C9.2636 8.66673 8.66667 9.26367 8.66667 10.0001V12.6667C8.66667 13.4031 9.2636 14.0001 10 14.0001H12.6667C13.4031 14.0001 14 13.4031 14 12.6667V10.0001ZM12.6667 10.0001V12.6667H10V10.0001H12.6667ZM6 8.66673C6.7364 8.66673 7.33333 9.26367 7.33333 10.0001V12.6667C7.33333 13.4031 6.7364 14.0001 6 14.0001H3.33333C2.59695 14.0001 2 13.4031 2 12.6667V10.0001C2 9.26367 2.59695 8.66673 3.33333 8.66673H6ZM6 10.0001H3.33333V12.6667H6V10.0001Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassify2Line);
export default __webpack_public_path__ + "static/media/classify_2_line.68a75c146d4826a4526d082be0c8302c.svg";
export { ForwardRef as ReactComponent };